import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function UpgradeSuccess() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "#F0F1EC" }}>
      <Navbar />
      <div className="max-w-lg mx-auto px-6 py-20">
        <div className="card p-10 text-center">
          <div className="text-7xl mb-6">🎉</div>
          <h2 className="font-display text-6xl tracking-wider mb-4" style={{ color: "#0A0B0F" }}>
            YOU'RE PREMIUM!
          </h2>
          <p className="font-condensed text-gray-400 tracking-wide text-lg mb-8">
            Thanks for upgrading. You can now create private leagues and challenge your mates.
          </p>
          <Link to="/leagues" className="btn-lime px-8 py-4 rounded-xl inline-block text-xl">
            CREATE A LEAGUE
          </Link>
        </div>
      </div>
    </div>
  );
}